import PraisoServices from "./PraisoServices";
import { getToken } from "./LocalStorageService";

export const GetContentDataAPI = async (status, userId, pageNumber, params) => {
    const ApiUrl = `campaign/contents`;
    const token = getToken();
    let data = {};
    if (params.impersonationid) {
        data = { requestedContentStatus: status, userId: params.impersonationid, pageNumber: pageNumber, impersonationId: params.impersonationid }
    } else {
        data = { requestedContentStatus: status, userId: userId, pageNumber: pageNumber, }
    }
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            { ...data },
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
              status: {
                code: 1,
                message: err?.message,
              },
              content: null,
            };
          }
        } catch (error_1) {
          const err = error_1 as Error;
          return {
            status: {
              code: 1,
              message: err.message,
            },
            content: null,
          };
        }
};

export const getContentData = async (status, userId, pageNumber, params) => {
    const data = await GetContentDataAPI(status, userId, pageNumber, params);
    return data;
};
